var render = function render(){var _vm=this,_c=_vm._self._c;return _c('activities',{staticClass:"card-icon is-size-2 is-ellipsed icon-activities has-text-secondary",attrs:{"activities":_vm.activities}})
}
var staticRenderFns = []

export { render, staticRenderFns }